import React from "react";
import Title from "../elements/Title";
import ProjectCard from "../elements/Card/Project";
import Fade from "react-reveal";

function Project(props, ref) {
  const project = props.project;
  return (
    <section className="px-3 py-12 pb-24 mx-auto container" ref={ref}>
      <Title
        title="Project"
        caption="Here are few project I’ve created recently"
      />
      <div className="lg:flex lg:flex-wrap lg:justify-center">
        <Fade bottom>
          {project.map((project, index) => {
            let className = "";
            if (!project.featured) className = "lg:flex hidden";
            return (
              <ProjectCard
                key={index}
                desc={project.desc}
                className={className}
                id={project.id}
                openProjectModal={props.openProjectModal}
                getProjectId={props.getProjectId}
              >
                <img
                  src={`/images/${project.logoUrl}`}
                  width="130rem"
                  className={project.logo_class}
                  alt={project.title}
                />
              </ProjectCard>
            );
          })}
        </Fade>
      </div>
    </section>
  );
}

const refProject = React.forwardRef(Project);
export default refProject;
